import $ from 'jquery';

window.$ = window.jQuery = $;

import 'jquery-ui';
import 'slick-carousel';
import 'picturefill/dist/picturefill';

const jQueryBridget = require( 'jquery-bridget' ); // required by isotope-layout
const Isotope = require( 'isotope-layout' );
jQueryBridget( 'isotope', Isotope, $ ); // make Isotope a jQuery plugin

// slick init
const initSlickCarousel = function () {

  const slickNextArrow = '<button class="slick-next" aria-label="volgende slide"><i class="fas fa-chevron-right"></i></button>',
    slickPrevArrow = '<button class="slick-prev" aria-label="vorige slide"><i class="fas fa-chevron-left"></i></button>';

  const slickNextArrowOfficials = '<button class="slick-next" aria-label="volgende trouwambtenaren zichtbaar maken"><i class="fas fa-chevron-right"></i></button>',
    slickPrevArrowOfficials = '<button class="slick-prev" aria-label="vorige trouwambtenaren zichtbaar maken"><i class="fas fa-chevron-left"></i></button>';

  const slickNextArrowLocations = '<button class="slick-next" aria-label="volgende locatie zichtbaar maken"><i class="fas fa-chevron-right"></i></button>',
    slickPrevArrowLocations = '<button class="slick-prev" aria-label="vorige locatie zichtbaar maken"><i class="fas fa-chevron-left"></i></button>';

  jQuery( '.promo-slider' ).slick( {
    slidesToScroll: 1,
    rows: 0,
    arrows: false,
    dots: true,
    dotsClass: 'slick-dots',
    adaptiveHeight: true,
    autoplay: false
  } );

  jQuery( '.possibilities-content-slider--slider' ).slick( {
    slidesToScroll: 1,
    rows: 0,
    arrows: true,
    dots: true,
    dotsClass: 'slick-dots',
    prevArrow: slickPrevArrow,
    nextArrow: slickNextArrow,
    adaptiveHeight: true,
    autoplay: false,
    infinite: false
  } );

  jQuery( '.wedding-official-slider' ).each( function () {
    const slider = jQuery( this ),
      dotsHolder = slider.closest( '.wedding-slider-wrap' ).find( '.slider-nav' );

    if (!slider.hasClass( 'slick-initialized' )) {
      slider.slick( {
        slidesToShow: 1,
        slidesToScroll: 1,
        rows: 0,
        arrows: true,
        dots: true,
        prevArrow: slickPrevArrowOfficials,
        nextArrow: slickNextArrowOfficials,
        adaptiveHeight: true,
        autoplay: false,
        mobileFirst: true,
        appendArrows: dotsHolder,
        appendDots: dotsHolder,
        infinite: false,
        responsive: [
          {
            breakpoint: 767,
            settings: {
              slidesToShow: 2
            }
          },
          {
            breakpoint: 991,
            settings: {
              slidesToShow: 3
            }
          }
        ]
      } );
    }
  } );

  jQuery( '.related-location-slider' ).slick( {
    slidesToShow: 3,
    slidesToScroll: 1,
    rows: 0,
    arrows: true,
    dots: false,
    adaptiveHeight: true,
    autoplay: false,
    infinite: false,
    prevArrow: slickPrevArrowLocations,
    nextArrow: slickNextArrowLocations,
    responsive: [
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 2
        }
      },
      {
        breakpoint: 768,
        settings: "unslick"
      }
    ]
  } );

  jQuery( window ).on( 'resize', function () {
    jQuery( '.related-location-slider' ).slick( 'resize' );
  } );
};

const initRetinaCover = function () {
  jQuery( '.bg-stretch' ).retinaCover();
};

// mobile menu init
const initMobileNav = function () {
  jQuery( 'body' ).mobileNav( {
    menuActiveClass: 'nav-active',
    menuOpener: '.nav-opener',
    hideOnClickOutside: true,
    menuDrop: '.nav-drop'
  } );
  jQuery( 'body' ).mobileNav( {
    menuActiveClass: 'search-active',
    menuOpener: '.search-opener',
    hideOnClickOutside: true,
    menuDrop: '.header .search-form'
  } );
};

const initFilter = function () {
  var $filterContent = jQuery( '.grid' );
  // filter items on button click
  $( '.filter-button-group' ).on( 'click', '.button', function (e) {
    e.preventDefault();
    var filterValue = $( this ).attr( 'data-filter' );
    $filterContent.isotope( {filter: filterValue} );
  } );
};

const initAutocomplete = function () {
  jQuery( 'input.autocomplete' ).uiAutocomplete( {
    source: 'inc/autocomplete-source.json',
    highlight: true
  } );
};

const initOpenClose = function () {
  ResponsiveHelper.addRange( {
    '..767': {
      on: function () {
        jQuery( '.location-open-close' ).openClose( {
          activeClass: 'active',
          opener: '.opener',
          slider: '.slide',
          animSpeed: 400,
          // hideOnClickOutside: fa,
          effect: 'slide'
        } );
      },
      off: function () {
        jQuery( '.location-open-close' ).openClose( 'destroy' );
      }
    }
  } );
};

const initiBackToTop = function () {
  var scrollBtn = jQuery( '.back-to-top' );

  $( window ).scroll( function () {
    if ($( window ).scrollTop() > 300) {
      scrollBtn.addClass( 'show' );
    } else {
      scrollBtn.removeClass( 'show' );
    }
  } );

  scrollBtn.on( 'click', function (e) {
    e.preventDefault();
    $( 'html, body' ).animate( {scrollTop: 0}, '300' );
  } );
};

;(function ($) {
  'use strict';

  initSlickCarousel();

  initFilter();
  initiBackToTop();

  cookies();
  cookieClickHandler();

  /**
   * Retina ImageCover
   */
  let styleRules = {};
  let generatedIds = new Set(); // Track generated IDs to avoid duplicates

  const templates = {
    '2x': [
      '(-webkit-min-device-pixel-ratio: 1.5)',
      '(min-resolution: 192dpi)',
      '(min-device-pixel-ratio: 1.5)',
      '(min-resolution: 1.5dppx)'
    ],
    '3x': [
      '(-webkit-min-device-pixel-ratio: 3)',
      '(min-resolution: 384dpi)',
      '(min-device-pixel-ratio: 3)',
      '(min-resolution: 3dppx)'
    ]
  };

  const addSimple = function (imageSrc, media, id) {
    var style = buildRule( id, imageSrc );

    addRule( media, style );
  };

  const addRetina = function (imageData, media, id) {
    var currentRules = templates[imageData[1]].slice();
    var patchedRules = currentRules;
    var style = buildRule( id, imageData[0] );

    if (media !== 'default') {
      patchedRules = $.map( currentRules, function (ele, i) {
        return ele + ' and ' + media;
      } );
    }

    media = patchedRules.join( ',' );

    addRule( media, style );
  };

  const buildRule = function (id, src) {
    return '#' + id + '{background-image: url("' + src + '");}';
  };

  const addRule = function (media, rule) {
    var $styleTag = styleRules[media];
    var styleTagData;
    var rules = '';

    if (media === 'default') {
      rules = rule + ' ';
    } else {
      rules = '@media ' + media + '{' + rule + '}';
    }

    if (!$styleTag) {
      styleRules[media] = $( '<style>' ).text( rules ).appendTo( 'head' );
    } else {
      styleTagData = $styleTag.text();
      styleTagData = styleTagData.substring( 0, styleTagData.length - 2 ) + ' }' + rule + '}';
      $styleTag.text( styleTagData );
    }
  };

  $.fn.retinaCover = function () {
    return this.each( function () {
      var $block = $( this );
      var $items = $block.children( '[data-srcset]' );
      var id = 'bg-stretch' + Date.now() + (Math.random() * 1000).toFixed( 0 );

      // Avoid duplicate IDs
      while (generatedIds.has( id )) {
        id = 'bg-stretch' + Date.now() + (Math.random() * 1000).toFixed( 0 );
      }

      generatedIds.add( id ); // Mark this ID as generated

      if ($items.length) {
        $block.attr( 'id', id );

        $items.each( function () {
          var $item = $( this );
          var data = $item.data( 'srcset' ).split( ', ' );
          var media = $item.data( 'media' ) || 'default';
          var dataLength = data.length;
          var itemData;
          var i;

          for (i = 0; i < dataLength; i++) {
            itemData = data[i].split( ' ' );

            if (itemData.length === 1) {
              addSimple( itemData[0], media, id );
            } else {
              addRetina( itemData, media, id );
            }
          }
        } );
      }

      $items.detach();
    } );
  };

  initRetinaCover();

  /**
   * MobileNavigation
   */
  const MobileNav = function (options) {
    this.options = $.extend( {
      container: null,
      hideOnClickOutside: false,
      menuActiveClass: 'nav-active',
      menuOpener: '.nav-opener',
      menuDrop: '.nav-drop',
      toggleEvent: 'click',
      outsideClickEvent: 'click touchstart pointerdown MSPointerDown'
    }, options );
    this.initStructure();
    this.attachEvents();
  };

  MobileNav.prototype = {
    initStructure: function () {
      this.page = $( 'html' );
      this.container = $( this.options.container );
      this.opener = this.container.find( this.options.menuOpener );
      this.drop = this.container.find( this.options.menuDrop );
    },
    attachEvents: function () {
      let self = this;

      if (activateResizeHandler) {
        activateResizeHandler();
        activateResizeHandler = null;
      }

      this.outsideClickHandler = function (e) {
        if (self.isOpened()) {
          let target = $( e.target );
          if (!target.closest( self.opener ).length && !target.closest( self.drop ).length) {
            self.hide();
          }
        }
      };

      this.openerClickHandler = function (e) {
        e.preventDefault();
        self.toggle();
      };

      this.opener.on( this.options.toggleEvent, this.openerClickHandler );
    },
    isOpened: function () {
      return this.container.hasClass( this.options.menuActiveClass );
    },
    show: function () {
      this.container.addClass( this.options.menuActiveClass );
      let opener = this.container.find( '.nav-opener' );
      opener.attr( 'aria-expanded', true );
      if (this.options.hideOnClickOutside) {
        this.page.on( this.options.outsideClickEvent, this.outsideClickHandler );
      }
    },
    hide: function () {
      this.container.removeClass( this.options.menuActiveClass );
      let opener = this.container.find( '.nav-opener' );
      opener.attr( 'aria-expanded', false );
      if (this.options.hideOnClickOutside) {
        this.page.off( this.options.outsideClickEvent, this.outsideClickHandler );
      }
    },
    toggle: function () {
      if (this.isOpened()) {
        this.hide();
      } else {
        this.show();
      }
    },
    destroy: function () {
      this.container.removeClass( this.options.menuActiveClass );
      this.opener.off( this.options.toggleEvent, this.clickHandler );
      this.page.off( this.options.outsideClickEvent, this.outsideClickHandler );
    }
  };

  let activateResizeHandler = function () {
    let win = $( window ),
      doc = $( 'html' ),
      resizeClass = 'resize-active',
      flag, timer;
    const removeClassHandler = function () {
      flag = false;
      doc.removeClass( resizeClass );
    };
    const resizeHandler = function () {
      if (!flag) {
        flag = true;
        doc.addClass( resizeClass );
      }
      clearTimeout( timer );
      timer = setTimeout( removeClassHandler, 500 );
    };
    win.on( 'resize orientationchange', resizeHandler );
  };

  $.fn.mobileNav = function (opt) {
    var args = Array.prototype.slice.call( arguments );
    var method = args[0];

    return this.each( function () {
      var $container = jQuery( this );
      var instance = $container.data( 'MobileNav' );

      if (typeof opt === 'object' || typeof opt === 'undefined') {
        $container.data( 'MobileNav', new MobileNav( $.extend( {
          container: this
        }, opt ) ) );
      } else if (typeof method === 'string' && instance) {
        if (typeof instance[method] === 'function') {
          args.shift();
          instance[method].apply( instance, args );
        }
      }
    } );
  };

  initMobileNav();

  /**
   * jQuery Autocomplete plugin
   */

  $.fn.uiAutocomplete = function (opt) {
    const termTemplate = '<strong class="ui-autocomplete-term">%s</strong>';

    return this.each( function () {
      let $input = $( this ),
        data = opt || {},
        uiInstance;

      if (data.highlight) {
        data.open = function (e, ui) {
          uiInstance.menu.element.find( 'li' ).each( function () {
            var $link = $( this );
            var regex = new RegExp( uiInstance.term, 'gi' );

            $link.html( $link.text().replace( regex, function (matched) {
              return termTemplate.replace( '%s', matched );
            } ) );
          } );
        };
      }

      $.Deferred( function (defer) {
        if (data.source) {
          $.getJSON( data.source )
            .done( defer.resolve )
            .fail( defer.reject );
        } else defer.resolve();
      } ).then( function (source) {
        uiInstance = $input.autocomplete( $.extend( {}, data, {
          source: source || data.request
        } ) ).data( 'ui-autocomplete' );
      } );
    } );
  };

  initAutocomplete();

  /**
   * jQuery Open/Close plugin
   */
  const OpenClose = function (options) {
    this.options = $.extend( {
      addClassBeforeAnimation: true,
      hideOnClickOutside: false,
      activeClass: 'active',
      opener: '.opener',
      slider: '.slide',
      animSpeed: 400,
      effect: 'fade',
      event: 'click'
    }, options );
    this.init();
  };

  OpenClose.prototype = {
    init: function () {
      if (this.options.holder) {
        this.findElements();
        this.attachEvents();
        this.makeCallback( 'onInit', this );
      }
    },
    findElements: function () {
      this.holder = $( this.options.holder );
      this.opener = this.holder.find( this.options.opener );
      this.slider = this.holder.find( this.options.slider );
    },
    attachEvents: function () {
      // add handler
      var self = this;
      this.eventHandler = function (e) {
        e.preventDefault();
        if (self.slider.hasClass( slideHiddenClass )) {
          self.showSlide();
        } else {
          self.hideSlide();
        }
      };
      self.opener.on( self.options.event, this.eventHandler );

      // hover mode handler
      if (self.options.event === 'hover') {
        self.opener.on( 'mouseenter', function () {
          if (!self.holder.hasClass( self.options.activeClass )) {
            self.showSlide();
          }
        } );
        self.holder.on( 'mouseleave', function () {
          self.hideSlide();
        } );
      }

      // outside click handler
      self.outsideClickHandler = function (e) {
        if (self.options.hideOnClickOutside) {
          var target = $( e.target );
          if (!target.is( self.holder ) && !target.closest( self.holder ).length) {
            self.hideSlide();
          }
        }
      };

      // set initial styles
      if (this.holder.hasClass( this.options.activeClass )) {
        $( document ).on( 'click touchstart', self.outsideClickHandler );
      } else {
        this.slider.addClass( slideHiddenClass );
      }
    },
    showSlide: function () {
      var self = this;
      if (self.options.addClassBeforeAnimation) {
        self.holder.addClass( self.options.activeClass );
      }
      self.slider.removeClass( slideHiddenClass );
      $( document ).on( 'click touchstart', self.outsideClickHandler );

      self.makeCallback( 'animStart', true );
      toggleEffects[self.options.effect].show( {
        box: self.slider,
        speed: self.options.animSpeed,
        complete: function () {
          if (!self.options.addClassBeforeAnimation) {
            self.holder.addClass( self.options.activeClass );
          }
          self.makeCallback( 'animEnd', true );
        }
      } );
    },
    hideSlide: function () {
      var self = this;
      if (self.options.addClassBeforeAnimation) {
        self.holder.removeClass( self.options.activeClass );
      }
      $( document ).off( 'click touchstart', self.outsideClickHandler );

      self.makeCallback( 'animStart', false );
      toggleEffects[self.options.effect].hide( {
        box: self.slider,
        speed: self.options.animSpeed,
        complete: function () {
          if (!self.options.addClassBeforeAnimation) {
            self.holder.removeClass( self.options.activeClass );
          }
          self.slider.addClass( slideHiddenClass );
          self.makeCallback( 'animEnd', false );
        }
      } );
    },
    destroy: function () {
      this.slider.removeClass( slideHiddenClass ).css( {
        display: ''
      } );
      this.opener.off( this.options.event, this.eventHandler );
      this.holder.removeClass( this.options.activeClass ).removeData( 'OpenClose' );
      $( document ).off( 'click touchstart', this.outsideClickHandler );
    },
    makeCallback: function (name) {
      if (typeof this.options[name] === 'function') {
        var args = Array.prototype.slice.call( arguments );
        args.shift();
        this.options[name].apply( this, args );
      }
    }
  };

  // add stylesheet for slide on DOMReady
  const slideHiddenClass = 'js-slide-hidden';
  (function () {
    var tabStyleSheet = $( '<style type="text/css">' )[0];
    var tabStyleRule = '.' + slideHiddenClass;
    tabStyleRule += '{position:absolute !important;left:-9999px !important;top:-9999px !important;display:block !important}';
    if (tabStyleSheet.styleSheet) {
      tabStyleSheet.styleSheet.cssText = tabStyleRule;
    } else {
      tabStyleSheet.appendChild( document.createTextNode( tabStyleRule ) );
    }
    $( 'head' ).append( tabStyleSheet );
  }());

  // animation effects
  const toggleEffects = {
    slide: {
      show: function (o) {
        o.box.stop( true ).hide().slideDown( o.speed, o.complete );
      },
      hide: function (o) {
        o.box.stop( true ).slideUp( o.speed, o.complete );
      }
    },
    fade: {
      show: function (o) {
        o.box.stop( true ).hide().fadeIn( o.speed, o.complete );
      },
      hide: function (o) {
        o.box.stop( true ).fadeOut( o.speed, o.complete );
      }
    },
    none: {
      show: function (o) {
        o.box.hide().show( 0, o.complete );
      },
      hide: function (o) {
        o.box.hide( 0, o.complete );
      }
    }
  };

  // jQuery plugin interface
  $.fn.openClose = function (opt) {
    var args = Array.prototype.slice.call( arguments );
    var method = args[0];

    return this.each( function () {
      var $holder = jQuery( this );
      var instance = $holder.data( 'OpenClose' );

      if (typeof opt === 'object' || typeof opt === 'undefined') {
        $holder.data( 'OpenClose', new OpenClose( $.extend( {
          holder: this
        }, opt ) ) );
      } else if (typeof method === 'string' && instance) {
        if (typeof instance[method] === 'function') {
          args.shift();
          instance[method].apply( instance, args );
        }
      }
    } );
  };
}( jQuery ));

/*
 * Responsive Layout helper
 */
window.ResponsiveHelper = (function ($) {
  // init variables
  var handlers = [],
    prevWinWidth,
    win = $( window ),
    nativeMatchMedia = false;

  // detect match media support
  if (window.matchMedia) {
    if (window.Window && window.matchMedia === Window.prototype.matchMedia) {
      nativeMatchMedia = true;
    } else if (window.matchMedia.toString().indexOf( 'native' ) > -1) {
      nativeMatchMedia = true;
    }
  }

  // prepare resize handler
  const resizeHandler = function () {
    var winWidth = win.width();
    if (winWidth !== prevWinWidth) {
      prevWinWidth = winWidth;

      // loop through range groups
      $.each( handlers, function (index, rangeObject) {
        // disable current active area if needed
        $.each( rangeObject.data, function (property, item) {
          if (item.currentActive && !matchRange( item.range[0], item.range[1] )) {
            item.currentActive = false;
            if (typeof item.disableCallback === 'function') {
              item.disableCallback();
            }
          }
        } );

        // enable areas that match current width
        $.each( rangeObject.data, function (property, item) {
          if (!item.currentActive && matchRange( item.range[0], item.range[1] )) {
            // make callback
            item.currentActive = true;
            if (typeof item.enableCallback === 'function') {
              item.enableCallback();
            }
          }
        } );
      } );
    }
  };

  win.bind( 'load resize orientationchange', resizeHandler );

  // test range
  const matchRange = function (r1, r2) {
    var mediaQueryString = '';
    if (r1 > 0) {
      mediaQueryString += '(min-width: ' + r1 + 'px)';
    }
    if (r2 < Infinity) {
      mediaQueryString += (mediaQueryString ? ' and ' : '') + '(max-width: ' + r2 + 'px)';
    }
    return matchQuery( mediaQueryString, r1, r2 );
  };

  // media query function
  const matchQuery = function (query, r1, r2) {
    if (window.matchMedia && nativeMatchMedia) {
      return matchMedia( query ).matches;
    } else if (window.styleMedia) {
      return styleMedia.matchMedium( query );
    } else if (window.media) {
      return media.matchMedium( query );
    }
    return prevWinWidth >= r1 && prevWinWidth <= r2;
  };

  // range parser
  const parseRange = function (rangeStr) {
    const rangeData = rangeStr.split( '..' ),
      x1 = parseInt( rangeData[0], 10 ) || -Infinity,
      x2 = parseInt( rangeData[1], 10 ) || Infinity;
    return [x1, x2].sort( function (a, b) {
      return a - b;
    } );
  };

  // export public functions
  return {
    addRange: function (ranges) {
      // parse data and add items to collection
      let result = {data: {}};
      $.each( ranges, function (property, data) {
        result.data[property] = {
          range: parseRange( property ),
          enableCallback: data.on,
          disableCallback: data.off
        };
      } );
      handlers.push( result );

      // call resizeHandler to recalculate all events
      prevWinWidth = null;
      resizeHandler();
    }
  };
}( jQuery ));

initOpenClose();

/**
 * Cookie handlers
 * 1. Set Cookie,
 * 2. Delete cookie,
 * 3. Get Cookie,
 * 4. Cookies,
 * 5. Click handler
 */

// Set cookie
function setCookie(params) {
  var name = params.name,
    value = params.value,
    expireDays = params.days,
    expireHours = params.hours,
    expireMinutes = params.minutes,
    expireSeconds = params.seconds;

  const expireDate = new Date();
  if (expireDays) {
    expireDate.setDate( expireDate.getDate() + expireDays );
  }
  if (expireHours) {
    expireDate.setHours( expireDate.getHours() + expireHours );
  }
  if (expireMinutes) {
    expireDate.setMinutes( expireDate.getMinutes() + expireMinutes );
  }
  if (expireSeconds) {
    expireDate.setSeconds( expireDate.getSeconds() + expireSeconds );
  }

  document.cookie = name + "=" + escape( value ) +
    ";domain=" + window.location.hostname +
    ";path=/" +
    ";expires=" + expireDate.toUTCString();
}

// Remove existing Cookie
function deleteCookie(name) {
  setCookie( {name: name, value: "", seconds: 1} );
}

// Check if cookie exists
function getCookie(cname) {
  var name = cname + "=";
  var decodedCookie = decodeURIComponent( document.cookie );
  var ca = decodedCookie.split( ';' );
  for (var i = 0; i < ca.length; i++) {
    var c = ca[i];
    while (c.charAt( 0 ) == ' ') {
      c = c.substring( 1 );
    }
    if (c.indexOf( name ) !== -1) {
      return c.substring( name.length, c.length );
    }
  }
  return '';
}

function cookies() {
  const acceptCookies = getCookie( 'acceptCookies' ),
    cookieBar = document.getElementById( "cookie-bar" );

  if (!cookieBar) {
    return;
  }

  if (!acceptCookies) {
    document.body.classList.add( 'show-cookie-bar' );
    cookieBar.classList.remove( 'd-none' );
    cookieBar.classList.add( 'd-flex' );
    //setCookie({name: "acceptCookies", value: true, days: 364 });
  } else {
    document.body.classList.remove( 'show-cookie-bar' );
    cookieBar.classList.add( 'd-none' );
    cookieBar.classList.remove( 'd-flex' );
    //deleteCookie("acceptCookies");
  }
}

function cookieClickHandler() {
  document.getElementById( 'js-acceptCookie' ) && document.getElementById( 'js-acceptCookie' ).addEventListener( 'click', function () {
    setCookie( {name: "acceptCookies", value: true, days: 364} );
    cookies();
    document.getElementById( "cookie-bar" ).classList.add( 'rs_skip' );
  }, false );
}

function initFilters() {
  let inputs = document.querySelectorAll( '.js-filter' );
  if (!inputs) {
    return;
  }

  // A simple function to handle the click event for each input.
  inputs.forEach( function (i) {
    i.onclick = function () {
      window.location = updateQueryStringParameter( window.location.href, i.name, i.value, i.checked );
    };
  } );
}
